import ApiService from 'Services/ApiService'

export default {
    list(query = null) {
        return ApiService.get('visits', query)
    },
    get(id) {
        return ApiService.get(`visits/${id}`, {with: 'issue,event'})
    },
    end(id) {
        return ApiService.get(`visits/${id}/end`)
    },
    getP1Reports(id) {
        return ApiService.get(`visits/${id}/p1-reports`)
    },
    history(issueId, field) {
        return ApiService.get(`visits/history/${issueId}`, {field: field})
    },
    last(id) {
        return ApiService.get(`visits/last/${id}`)
    },
    create(data) {
        return ApiService.post('visits', data)
    },
    updateField(id, value, field) {
        let data = {}
        data[field] = value
        return ApiService.put(`visits/${id}`, data, {
            field: field,
            with: 'issue,event'
        })
    },
    update(visit) {
        return ApiService.put(`visits/${visit.id}`, visit)
    },
    delete(id) {
        return ApiService.delete(`visits/${id}`)
    }
}
